import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import {
  useGetShipmentDetailQuery,
  useUpdateShipmentForVendorSideMutation,
} from "store/services/shipmentApi";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import { useAppMeta, useAuth } from "hooks";
import ShipmentVendorForm from "./ShipmentComponents/ShipmentVendorForm";

const ShipmentVendorEditScreen = () => {
  const { id } = useParams();
  const { isVendor, isVendorStaff } = useAuth();
  const basePath = isVendor
    ? "/app/vendor/shipment"
    : "/app/crm/shipment" || isVendorStaff
      ? "/app/staff/shipment"
      : "/app/crm/shipment";

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Shipment", path: "/app/vendor/shipment/list" },
    { title: "Edit Shipment" },
  ];

  // RTK Query
  const {
    data: shipmentDetail,
    isLoading: loadingShipment,
    error,
  } = useGetShipmentDetailQuery(id);

  const [updateShipment, { isLoading: updatingShipment }] =
    useUpdateShipmentForVendorSideMutation();

  //methods
  const handleUpdateShipment = async (data) => {
    const _payload = data;

    delete _payload.disclaimers;
    try {
      await updateShipment({ ..._payload }).unwrap();
      toast.success("Shipment successfully updated!");
      navigate(`${basePath}/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update Shipment!"
      );
    }
  };

  useAppMeta("Edit Shipment");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingShipment || updatingShipment}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <ShipmentVendorForm
          isBusy={loadingShipment || updatingShipment}
          ShipmentDetail={shipmentDetail}
          onSubmit={handleUpdateShipment}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default ShipmentVendorEditScreen;
